import React from "react";
import EasyCropper, { Size } from "react-easy-crop";
import { useImageCropContext } from "./ImageCropProvider";
import styles from "./ImageInput.module.scss";
import { Tooltip } from "react-tooltip";

interface CropperProps {
  cropShape?: "round" | "rect";
  aspectRatio?: number;
  showGrid?: boolean;
  cropSize?: Size;
  showFaceOverlayGuide?: boolean;
  style?: {
    containerStyle?: React.CSSProperties;
    mediaStyle?: React.CSSProperties;
    cropAreaStyle?: React.CSSProperties;
  };
  faceOverlayTooltip?: React.ReactNode;
}

const Cropper = ({
  cropShape = "rect",
  aspectRatio,
  showGrid = true,
  cropSize,
  showFaceOverlayGuide = false,
  style,
  faceOverlayTooltip,
}: CropperProps) => {
  const context = useImageCropContext();
  if (!context)
    throw new Error(
      "<Cropper /> should not be used outside of <ImageCropProvider />",
    );
  const {
    image,
    zoom,
    setZoom,
    rotation,
    setRotation,
    crop,
    setCrop,
    onCropComplete,
  } = context;

  return (
    <>
      <EasyCropper
        image={image || undefined}
        crop={crop}
        zoom={zoom}
        rotation={rotation}
        cropShape={cropShape}
        aspect={aspectRatio}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
        onRotationChange={setRotation}
        showGrid={showGrid}
        cropSize={cropSize}
        style={style}
        restrictPosition={false}
      />
      {showFaceOverlayGuide && (
        <>
          <div
            id="cropper-face-overlay-guide"
            className={styles.faceOverlayGuideContainer}
          >
            <div className={styles.faceOverlayGuideOval} />
          </div>

          {faceOverlayTooltip && (
            <Tooltip
              anchorSelect="#cropper-face-overlay-guide"
              isOpen={true}
              style={{ maxWidth: 450, zIndex: 10 }}
            >
              {faceOverlayTooltip}
            </Tooltip>
          )}
        </>
      )}
    </>
  );
};

export default Cropper;
